import type { AxiosRequestConfig, AxiosResponse } from 'axios';

import client from 'api/client';
import { IsAssessmentAgreementSignedData } from 'api/models/response/AssessmentAgreement';
import type { AgreementSummary } from 'types';

/** Own agreement when `userID` is omitted; otherwise the given candidate's (agents / spouse). */
const assessmentAgreementPath = (userID?: string | number) =>
    userID ? `/assessment_agreement/${userID}` : '/assessment_agreement';

export function get(userID?: string | number): Promise<AxiosResponse<AgreementSummary>> {
    return client.get<AgreementSummary>(assessmentAgreementPath(userID));
}

/** Unsigned PDF render; the backend answers 409 once signed (use `summary.pdf_url` instead). */
export function getPdf(userID?: string | number): Promise<AxiosResponse<Blob>> {
    return client.get<Blob>(`${assessmentAgreementPath(userID)}/pdf`, { responseType: 'blob' });
}

export function post(payload: FormData, customConfig?: AxiosRequestConfig<FormData>) {
    return client.post(`/assessment_agreement`, payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
        ...customConfig,
    });
}

export const getAssessmentAgreementStatusForUser = (): Promise<
    AxiosResponse<IsAssessmentAgreementSignedData>
> => {
    return client.get<IsAssessmentAgreementSignedData>(`/assessment_agreement_status`);
};

export const getAssessmentAgreementByClientId = (
    client_id: string
): Promise<AxiosResponse<IsAssessmentAgreementSignedData>> => {
    return client.get<IsAssessmentAgreementSignedData>(`/assessment_agreement_status/${client_id}`);
};
